module.exports = __webpack_public_path__ + "f4998772755ee331d7426abe9024b4e7.pdf";